<script>
    import Icon from './Icon.svelte';
    import poweredBadge from '../assets/logo.svg?raw';
</script>

<div class="powered">
    <a href="https://salonhub.nl">
        <Icon data={poweredBadge} />
    </a>
</div>

<style>
    .powered {
        grid-column: 3;
        grid-row: 3;
        align-self: start;
        display: flex;
    }

    a {
        background-color: rgba(255, 255, 255, 0.6);
        border-radius: 0 0 8px 8px;
        padding: 1.8em 1.1em 0.8em 1.1em;
        display: flex;
        align-items: center;
        position: relative;
        top: -1.2em;
        margin-bottom: 1em;
    }

    @media (prefers-color-scheme: dark) {
        a {
            background-color: rgba(0, 0, 0, 0.4);
        }
    }

    @media (max-width: 600px) {
        .powered {
            position: absolute;
            bottom: 0;
            left: 0;
            padding: 1em;
            margin-bottom: 0;
        }
        
        a {
            background-color: var(--background-color);
            border-radius: 0;
            top: auto;
            margin-bottom: 0;
        }
    }

    a :global(svg) {
        width: 70px;
        fill: var(--accent-background);

        /* Cap the accent's lightness so a bright brand colour still reads dark here
           (OKLCH L is perceptual). Older engines fall back to the plain var above. */
        fill: oklch(from var(--accent-background) min(l, 0.5) c h);
    }

    @media (prefers-color-scheme: dark) {
        a :global(svg) {
            fill: #cccccc;

            /* Mirror of the light case: floor the lightness high and cap chroma low, so
               the badge shows a soft, desaturated light tint of the brand colour on dark. */
            fill: oklch(from var(--accent-background) max(l, 0.7) min(c, 0.06) h);
        }
    }
</style>